import React from 'react';

import './Skeleton.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  count?: number;
  circle?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  count = 1,
  circle = false,
}) => {
  return (
    <div className="skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="skeleton"
          style={{
            width: circle ? height : width,
            height,
            borderRadius: circle ? '50%' : borderRadius,
          }}
        />
      ))}
    </div>
  );
};

export default Skeleton;